import { Container } from '@ztechapps/webui.contract'
import { productContainer } from '@ztechapps/product.webui'
import { workOrderContainer } from '@ztechapps/work-order.webui'
import { adjustmentContainer } from '@ztechapps/adjustment.webui'
import { purchaseOrderContainer } from '@ztechapps/purchase-order.webui'
import { vendorContainer } from '@ztechapps/vendor.webui'
import { aiWebuiContainer } from '@ztechapps/ai.webui'

export function setupContainer() {
  const container = new Container()
  container.load(
    productContainer,
    workOrderContainer,
    adjustmentContainer,
    purchaseOrderContainer,
    vendorContainer,
    aiWebuiContainer
  )

  return container
}
